import { Alert, Button } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { FaPlus, FaTrash } from "react-icons/fa";
import { z } from "zod";

import ReactTextFormGroup from "../../FormGroups/TextFormGroup.jsx";

const CROPS = ["inventory_management", "strawberry", "osteospermum"];
const SERVICE_NAMES = ["growth_stage", "canopy_detection"];

export const CallQuantumSettingsSchema = z.object({
    quantumEndpoints: z.array(
        z.object({
            crop: z.string().optional(),
            serviceName: z.string().optional(),
            variety: z.string().optional(),
        }),
    ),
});

export const CallQuantumSettingsValues = (settings) => {
    return {
        quantumEndpoints: settings.quantumEndpoints,
    };
};

export default function CallQuantumFormFields({
    control,
    errors,
    setValue,
    defaultAppSettings,
}) {
    const { append, remove } = useFieldArray({
        control,
        name: "settings.quantumEndpoints",
    });

    const default_values = defaultAppSettings.quantumEndpoints;
    const crop_options = CROPS.map((c) => {
        return { id: c, name: c };
    });
    const service_options = SERVICE_NAMES.map((s) => {
        return { id: s, name: s };
    });
    return (
        <>
            <h4>Quantum endpoints</h4>

            {default_values.length === 0 && (
                <Alert variant="secondary" className="mb-3">
                    No quantum endpoints configured.
                </Alert>
            )}

            {default_values.map((_, index) => (
                <div
                    // biome-ignore lint/suspicious/noArrayIndexKey: Quantum endpoints have no stable unique identifier and form fields are position-based.
                    key={`endpoint_${index}`}
                    className="d-flex justify-content-between align-items-start gap-2 mb-3"
                >
                    <div
                        className={`flex-grow-1 ${
                            index !== default_values.length - 1
                                ? "border-bottom pb-3"
                                : ""
                        }`}
                    >
                        <ReactTextFormGroup
                            label="Crop"
                            name={`settings.quantumEndpoints.${index}.crop`}
                            placeholder={`Leave empty to use ${default_values[index].crop}`}
                            isMulti={false}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            options={crop_options}
                        />

                        <ReactTextFormGroup
                            label="Service name"
                            name={`settings.quantumEndpoints.${index}.serviceName`}
                            options={service_options}
                            isMulti={false}
                            placeholder={`Leave empty to use ${default_values[index].serviceName}`}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                        />

                        <ReactTextFormGroup
                            label="Variety name"
                            name={`settings.quantumEndpoints.${index}.variety`}
                            isMulti={true}
                            placeholder={
                                default_values[index]?.variety || "default"
                            }
                            control={control}
                            errors={errors}
                            setValue={setValue}
                        />
                    </div>

                    <Button
                        variant="danger"
                        type="button"
                        onClick={() => remove(index)}
                        className="flex-shrink-0 mt-4"
                    >
                        <FaTrash />
                    </Button>
                </div>
            ))}

            <div className="d-flex justify-content-end mt-2">
                <Button
                    variant="success"
                    type="button"
                    onClick={() =>
                        append({
                            id: "",
                            parts: [],
                        })
                    }
                >
                    <FaPlus className="me-2" />
                    Add endpoint
                </Button>
            </div>
        </>
    );
}
